module.exports = __webpack_public_path__ + "img/logo.611101f4.png";